import React from "react";
import { ArrowRight, GitBranch } from "lucide-react";

export const Hero = ({ onCtaServices, onCtaValidation }) => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative overflow-hidden pt-32 pb-20 lg:pt-40 lg:pb-28"
    >
      {/* Aurora + dot grid */}
      <div className="absolute inset-0 bg-aurora pointer-events-none" />
      <div className="absolute inset-0 bg-dot-grid opacity-60 pointer-events-none" />
      {/* Soft radial fade at bottom */}
      <div
        className="absolute inset-x-0 bottom-0 h-40 pointer-events-none"
        style={{
          background:
            "linear-gradient(180deg, rgba(251,251,253,0) 0%, #FBFBFD 100%)",
        }}
      />

      <div className="relative mx-auto max-w-7xl px-5 lg:px-10">
        {/* Eyebrow chip */}
        <div className="flex justify-center reveal">
          <span className="chip" data-testid="hero-eyebrow">
            <GitBranch size={14} className="text-brand-light" />
            <span className="font-mono text-[12px] tracking-tight text-ink-200">
              Swiss AI Consultancy
            </span>
          </span>
        </div>

        {/* Headline */}
        <h1
          data-testid="hero-headline"
          className="mt-9 text-center headline reveal reveal-d1 max-w-5xl mx-auto"
          style={{
            fontSize: "clamp(2.2rem, 5.2vw, 4.4rem)",
          }}
        >
          AI Solutions
          <br />
          for <em>Modern Businesses</em>.
        </h1>

        {/* Subhead */}
        <p
          data-testid="hero-subheadline"
          className="mt-8 max-w-2xl mx-auto text-center text-[16.5px] lg:text-[17.5px] leading-[1.7] text-ink-200/75 font-light reveal reveal-d2"
        >
          A Swiss AI consultancy helping businesses implement AI, automation
          and intelligent workflows that save time, reduce costs and grow.
        </p>

        {/* CTAs */}
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4 reveal reveal-d3">
          <button
            type="button"
            data-testid="hero-cta-services"
            onClick={onCtaServices}
            className="btn-pill-dark"
          >
            Book Free Consultation
            <ArrowRight size={16} />
          </button>
          <button
            type="button"
            data-testid="hero-cta-validation"
            onClick={onCtaValidation}
            className="btn-pill-light"
          >
            Explore Solutions
          </button>
        </div>

        {/* Trust dots */}
        <div
          data-testid="hero-trustdots"
          className="mt-10 flex flex-wrap items-center justify-center gap-x-10 gap-y-3 reveal reveal-d4"
        >
          {[
            "Swiss-based",
            "Business-first AI",
            "Compliance-aware",
          ].map((t) => (
            <div key={t} className="flex items-center gap-2.5">
              <span className="w-1.5 h-1.5 rounded-full bg-brand-light" />
              <span className="font-mono text-[12.5px] text-ink-200/80">
                {t}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
